import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicComponent } from './public-component/public-component';

const routes: Routes = [
  {
    path: '',
    component: PublicComponent,
    children: [
      {
        path: 'blogs',
        loadChildren: () =>
          import('./blogs/blogs-module').then((m) => m.BlogsModule),
      },
      {
        path: 'about-us',
        loadComponent: () =>
          import('./about-us-component/about-us-component').then(
            (c) => c.AboutUsComponent,
          ),
      },
      {
        path: 'how-it-works',
        loadComponent: () =>
          import('./how-it-works-component/how-it-works-component').then(
            (c) => c.HowItWorksComponent,
          ),
      },
      {
        path: 'repository',
        loadComponent: () =>
          import('./data-repository-component/data-repository-component').then(
            (c) => c.DataRepositoryComponent,
          ),
      },
      {
        path: 'terms-of-service',
        loadComponent: () =>
          import(
            './terms-of-service-component/terms-of-service-component'
          ).then((c) => c.TermsOfServiceComponent),
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('./privacy-policy/privacy-policy-component').then(
            (c) => c.PrivacyPolicyComponent,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicRoutingModule {}
